import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './Componets/Auth/Login/Login';
import Register from './Componets/Auth/Register/Register';
import NoMatch from './Componets/NoMatch/NoMatch';
import AdmissionCourseDetails from './Componets/Pages/AdmissionPages/AdmissionCourseDetails';
import AdmissionPages from './Componets/Pages/AdmissionPages/AdmissionPages';
import BookStorePages from './Componets/Pages/BookStorePages/BookStorePages';
import HomePages from './Componets/Pages/HomePages/HomePages';
import JobPreperationDetails from './Componets/Pages/HomePages/JobPreperation/JobPreperationDetails';
import PopularCourseDetails from './Componets/Pages/HomePages/PopularCourse/PopularCourseDetails';
import JobPages from './Componets/Pages/JobPages/JobPages';
import OneToTen from './Componets/Pages/OneToTen/OneToTen';
import OneToTenCourseDetails from './Componets/Pages/OneToTen/OneToTenCourse/OneToTenCourseDetails';
import Profile from './Componets/Pages/Profile/Profile';
import SkillsPages from './Componets/Pages/SkillsPages/SkillsPages';
import ScrollToTop from './Componets/ScrollToTop/ScrollToTop';
import Footer from './Componets/Shared/Footer/Footer';
import Navbar from './Componets/Shared/Navbar/Navbar';


const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path='/' element={<HomePages />}></Route>
        {/* ==============================All Pages Start=============================== */}
        <Route path='/class1to12' element={<OneToTen />}></Route>
        <Route path='/skills' element={<SkillsPages />}></Route>
        <Route path='/admission' element={<AdmissionPages />}></Route>
        <Route path='/bookStore' element={<BookStorePages />}></Route>
        <Route path='/jobPreperation' element={<JobPages />}></Route>
        {/* ==============================All Pages End=============================== */}


        {/* ==============================All Pages Details Start=============================== */}
        <Route path='/popularCourseDetails/:id' element={<PopularCourseDetails />}></Route>
        <Route path='/freePaidCourseDetails/:id' element={<AdmissionCourseDetails />}></Route>
        <Route path='/jobPreperationDetails/:id' element={<JobPreperationDetails />}></Route>
        <Route path='/lesson/:id' element={<OneToTenCourseDetails />}></Route>
        {/* ==============================All Pages Details End=============================== */}



        {/* ==============================Authentication Details Start=============================== */}
        <Route path='/login' element={<Login />}></Route>
        <Route path='/register' element={<Register />}></Route>
        <Route path='/profile' element={<Profile />}></Route>
        {/* ==============================Authentication Details End=============================== */}

        {/* 404 Pages  */}
        <Route path='*' element={<NoMatch />}></Route>

      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;